import React from 'react'
import { Trans } from 'react-i18next'
import { Link } from 'react-router-dom'

const currentYear = new Date().getFullYear()

export const Footer = () => {

  return (
    <footer className="w-full py-3 mt-9">
      <div className="container text-center footer-content">
        <p><Trans>companyName</Trans></p>
        <p><button className="ot-sdk-show-settings" id="ot-sdk-btn"><Trans>cookieSettings</Trans></button></p>
        <p><Link className="footer-link" to="/countries"><Trans>countries</Trans></Link></p>
        <p><Link className="footer-link" to="/privacy-policy"><Trans>termsAndConditionsBtn</Trans></Link></p>
        <p>&copy; {currentYear} <Trans>arr</Trans></p>
      </div>
    </footer>
  )
}

export default Footer
